(function (global) {
  'use strict';
  // Explicit rollout allowlists, verified against account settings 2026-10-05.
  var SMS = ['US','CA','GB','FR','DE','CH','SE','NO','DK','IT','PT','PL','LU'];
  var WA = ['NL']; // NL collection only. Sending remains paused pending sender approval.
  var COUNTRIES = {AU:'Australia',AT:'Austria',BE:'Belgium',CA:'Canada',DK:'Denmark',FI:'Finland',FR:'France',DE:'Germany',IE:'Ireland',IT:'Italy',LU:'Luxembourg',NL:'Netherlands',NZ:'New Zealand',NO:'Norway',PL:'Poland',PT:'Portugal',ES:'Spain',SE:'Sweden',CH:'Switzerland',GB:'United Kingdom',US:'United States'};
  var DIAL_CODES = {AU:'61',AT:'43',BE:'32',CA:'1',DK:'45',FI:'358',FR:'33',DE:'49',IE:'353',IT:'39',LU:'352',NL:'31',NZ:'64',NO:'47',PL:'48',PT:'351',ES:'34',SE:'46',CH:'41',GB:'44',US:'1'};
  function eligible(country) { return {sms:SMS.indexOf(country)>-1,whatsapp:WA.indexOf(country)>-1}; }
  function cohort(email) {
    var hash=2166136261, key=('bj-mobile-recovery-v1:'+email.trim().toLowerCase());
    for(var i=0;i<key.length;i++) hash=Math.imul(hash^key.charCodeAt(i),16777619)>>>0;
    return hash%100<20?'email_only':'mobile';
  }
  function payload(email, phone, channel, country) {
    if (!email || !phone || !eligible(country)[channel]) throw new Error('Channel not available');
    var subscriptions = {};
    subscriptions[channel] = {marketing:{consent:'SUBSCRIBED'}};
    return {data:{type:'subscription',attributes:{
      custom_source:'Billie Jeans existing scratch popup / mobile v1 / '+channel,
      profile:{data:{type:'profile',attributes:{email:email,phone_number:phone,
        properties:{bj_mobile_recovery_cohort:cohort(email),bj_mobile_recovery_experiment:'v1',bj_mobile_form_version:'2026-10-05-worldwide',bj_mobile_phone_country:country,
          bj_mobile_consent_text:'WhatsApp & SMS offers and cart reminders',
          bj_mobile_signup_source:'existing-scratch-popup'},
        subscriptions:subscriptions}}}
    },relationships:{list:{data:{type:'list',id:channel==='sms'?'VLJPv3':'RcyF4p'}}}}};
  }
  function validate(lib, raw, country) {
    var number = lib.parsePhoneNumberFromString(raw, country);
    if (!number || !number.isValid() || (country && number.country !== country) ||
        ['MOBILE','FIXED_LINE_OR_MOBILE'].indexOf(number.getType()) < 0) {
      throw new Error('Enter a valid mobile number for the selected country.');
    }
    return number.number;
  }
  function init(config) {
    var form=config.root.querySelector('[data-bj-mobile]'),select=form.querySelector('select'),
      phone=form.querySelector('input[type=tel]'),sms=form.querySelector('[name=bj_sms]'),
      summary=form.querySelector('summary'),button=config.root.querySelector('button[type=submit]'),libPromise=null,startedCountry=config.country;
    Object.keys(COUNTRIES).sort(function(a,b){return COUNTRIES[a].localeCompare(COUNTRIES[b]);}).forEach(function(c){
      var option=document.createElement('option');option.value=c;
      option.textContent=(c==='GB'?'UK':c)+' +'+DIAL_CODES[c];
      option.setAttribute('aria-label',COUNTRIES[c]+' +'+DIAL_CODES[c]);select.appendChild(option);
    });
    var other=document.createElement('option');other.value='';other.textContent='Other country';select.appendChild(other);
    select.value=COUNTRIES[startedCountry]?startedCountry:'';
    function update() {
      sms.closest('label').hidden=false;sms.disabled=false;
      var label=sms.closest('label').querySelector('span');
      if(label)label.textContent='WhatsApp & SMS offers and cart reminders';
      summary.textContent='Receive exclusive offers on WhatsApp & SMS';
      phone.placeholder=select.value?'Mobile number':'Include country code, e.g. +31';
      updateButton();
      form.querySelector('[data-bj-mobile-unavailable]').hidden=true;
      form.querySelector('[data-bj-mobile-legal-sms]').hidden=false;
      form.querySelector('[data-bj-mobile-legal-wa]').hidden=true;
    }
    function updateButton() {
      var active=form.open&&!form.hidden&&phone.value.trim()&&sms.checked;
      button.textContent=active?'JOIN WHATSAPP & SMS':'SHOW MY CODE';
    }
    function loadLib() {
      if(global.libphonenumber)return Promise.resolve(global.libphonenumber);
      if(!libPromise)libPromise=new Promise(function(resolve,reject){
        var script=document.createElement('script');script.src=config.phoneScript;script.async=true;
        var timer=setTimeout(function(){reject(new Error('Phone validation unavailable.'));},10000);
        script.onload=function(){clearTimeout(timer);global.libphonenumber?resolve(global.libphonenumber):reject(new Error('Phone validation unavailable.'));};
        script.onerror=function(){clearTimeout(timer);reject(new Error('Phone validation unavailable.'));};
        document.head.appendChild(script);
      }).catch(function(error){libPromise=null;throw error;});
      return libPromise;
    }
    select.addEventListener('change',function(){sms.checked=false;phone.value='';update();});
    phone.addEventListener('input',updateButton);
    phone.addEventListener('change',updateButton);
    sms.addEventListener('change',updateButton);
    form.addEventListener('toggle',function(){
      if(form.open)loadLib().catch(function(){});
      else {sms.checked=false;}
      updateButton();
    });
    function reset(){
      form.open=false;sms.checked=false;phone.value='';select.value=COUNTRIES[startedCountry]?startedCountry:'';
      form.hidden=false;update();
    }
    reset();
    return {
      reset:reset,
      updateButton:updateButton,
      submit:function(email){
        if(config.preview||!form.open||form.hidden)return Promise.resolve('');
        var country=select.value,raw=phone.value.trim();
        if(!sms.checked)return Promise.resolve('');
        function post(path,body){
          var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},12000);
          return fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+encodeURIComponent(config.siteId),{
            method:'POST',headers:{'Content-Type':'application/json','revision':'2026-07-15'},
            signal:controller.signal,body:JSON.stringify(body)
          }).then(function(response){if(!response.ok)throw new Error('Phone signup failed.');})
            .finally(function(){clearTimeout(timer);});
        }
        return loadLib().then(function(lib){
          var normalized=validate(lib,raw,country);
          country=lib.parsePhoneNumberFromString(normalized).country;
          var allowed=eligible(country),channels=['whatsapp','sms'];
          // Record the explicit choice independently of provider availability. These
          // properties are consent evidence, not Klaviyo's native sending permission.
          var props={bj_mobile_signup_phone:normalized,bj_mobile_phone_country:country,
            bj_mobile_signup_source:'existing-scratch-popup',bj_mobile_form_version:'2026-10-05-worldwide',
            bj_mobile_requested_channels:channels,bj_mobile_requested_at:new Date().toISOString(),
            bj_mobile_consent_text:'WhatsApp & SMS offers and cart reminders',
            bj_mobile_recovery_cohort:cohort(email),bj_mobile_recovery_experiment:'v1',
            bj_mobile_registration_pending:channels};
          function save(){return post('profiles',{data:{type:'profile',attributes:{email:email,phone_number:normalized,properties:props}}});}
          return save().then(function(){
            // A failed or unavailable channel must not discard the other choice.
            return Promise.all(channels.map(function(channel){
              if(!allowed[channel])return Promise.resolve(channel);
              return post('subscriptions',payload(email,normalized,channel,country)).then(function(){return null;},function(){return channel;});
            }));
          }).then(function(pending){
            props.bj_mobile_registration_pending=pending.filter(Boolean);
            return save().catch(function(){/* Initial record remains queued for review. */});
          });
        }).then(function(){return 'Your WhatsApp and SMS marketing preferences are saved.';});
      }
    };
  }
  if(typeof module==='object'&&module.exports) module.exports={eligible:eligible,payload:payload,validate:validate,cohort:cohort};
  else global.BJScratchMobile={init:init};
})(typeof window!=='undefined'?window:this);
